/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Button/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Button({
  children,
  viewPath = "/DesignSystem/Button",
  alignSelf = "auto",
  order = "unset",
  backgroundColor = "rgba(111,111,111, 0.05)",
  borderBottomRightRadius = 8,
  borderColor = "rgba(111,111,111, 0)",
  borderStyle = "solid",
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  borderWidth = 0,
  pointerEvents = "auto",
  id,
  isDisabled,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  marginBottom = 0,
  onClick,
  goTo,
  paddingBottom = 18,
  paddingLeft = 32,
  paddingRight = 32,
  paddingTop = 18,
  opacity = 1,
  width = "auto",
  backgroundColorHovered = "rgba(111,111,111, 0.2)",
  isSelected,
  fontSize = 14,
  color = "#404040",
  text = "Default Label"
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="Button.Vertical"
  data-view-path={viewPath}
 id={id}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--as-1-2mwm5H': alignSelf,'--o-2-2mwm5H': order,'--bbrr-4-2mwm5H': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--bc-5-2mwm5H': borderColor,'--bs-6-2mwm5H': borderStyle,'--btlr-7-2mwm5H': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-8-2mwm5H': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bw-9-2mwm5H': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--pe-10-2mwm5H': pointerEvents,'--ml-11-2mwm5H': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-12-2mwm5H': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-13-2mwm5H': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-14-2mwm5H': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pb-15-2mwm5H': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-16-2mwm5H': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-17-2mwm5H': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-18-2mwm5H': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-20-2mwm5H': typeof width === 'number' ? `${width}px` : width,'--bc-3-2mwm5H': isSelected ? "rgba(19,126,197,0.7)" : isHovered ? backgroundColorHovered : backgroundColor,'--o-19-2mwm5H': isBefore ? 0 : opacity}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Button.Text"
  data-view-path={viewPath}
 style={{'--fs-21-2mwm5H': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--c-22-2mwm5H': isSelected ? "white" : color}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</a>
{children}
</React.Fragment>)
}